import { Component, OnInit, OnDestroy, inject } from '@angular/core';
import { ADD_SOURCE_LIST_NAME_KEY, buildAddSource, isUboxCartPage } from '../../../../dto';
import { Router } from '@angular/router';
import { buildBulkCartRequest, canBuildCartRequest, resolveCartRequestUrl } from '../../../../common/cart-request.util';
import {
  calcOutBoxUnitPriceUsd,
  resolveOutBoxUnitEa,
} from '../../../../shared/components/product-order-unit-selector/out-box-order-unit.util';
import { CartService, ProductService, GaService, UtmStorageService } from '../../../../services';
import { BaseComponent } from '../../../../core';
import * as CartStore from '../../../../store/cart';
@Component({
  selector: 'app-select-bulk-product',
  templateUrl: './select-bulk-product.component.html',
  styleUrls: ['./select-bulk-product.component.scss'],
  standalone: false,
})
export class SelectBulkProductComponent extends BaseComponent implements OnInit, OnDestroy {
  private cartService = inject(CartService);
  productService = inject(ProductService);
  private gaService = inject(GaService);
  private utmStorage = inject(UtmStorageService);
  private router = inject(Router);

  selectedProducts;
  sendSelectedProducts;
  isShowAddToCartModal: boolean;
  isCheckedAll;
  totalLength;
  ngOnInit() {
    this.productService.openOptionSubject$.subscribe(() => {
      this.selectedProducts = this.productService.selectProducts;
      this.totalLength = this.selectedProducts.length + this.productService.cartsProductLength;
      if (this.totalLength > this.productService.maxProduct) {
        this.selectedProducts = this.selectedProducts.map((selectedProduct, index) => {
          if (index + this.productService.cartsProductLength < this.productService.maxProduct) {
            return selectedProduct;
          } else {
            return {
              ...selectedProduct,
              addBulkChecked: false,
            };
          }
        });
      }
      this.cehckAllSelect();
      this.sendSelectedProducts = this.selectedProducts;
      this.sendSelectedProducts = this.selectedProducts.filter((selectedProduct) => selectedProduct.addBulkChecked);
      this.isShowAddToCartModal = true;
    });
  }

  isSelectedProductOutBoxUnit(selectedProduct): boolean {
    return (
      isUboxCartPage(resolveCartRequestUrl(this.router.url, selectedProduct?.cartContextUrl)) &&
      resolveOutBoxUnitEa(selectedProduct?.productOption?.outboxQuantity) !== null
    );
  }

  getSelectedProductDisplayPriceUsd(selectedProduct): number {
    const unitPriceUsd = selectedProduct?.productOption?.salePriceUSD ?? 0;
    const outboxQuantity = resolveOutBoxUnitEa(selectedProduct?.productOption?.outboxQuantity);
    return this.isSelectedProductOutBoxUnit(selectedProduct) && outboxQuantity
      ? calcOutBoxUnitPriceUsd(unitPriceUsd, outboxQuantity)
      : unitPriceUsd;
  }

  addToSelect(product) {
    if (
      !product.addBulkChecked &&
      !canBuildCartRequest(product, resolveCartRequestUrl(this.router.url, product.cartContextUrl))
    ) {
      return;
    }
    let _selectedProducts = this.selectedProducts.filter((selectedProduct) => selectedProduct.addBulkChecked);

    if (!product.addBulkChecked) {
      if (this.productService.cartsProductLength + _selectedProducts.length >= this.productService.maxProduct) {
        const dialog = this._openDialog({
          message: `Cannot hold any more. Maximum of ${this.productService.maxProduct} can be held.`,
          close: () => {
            dialog.close();
          },
        });
        return;
      }
    }

    product.addBulkChecked = !product.addBulkChecked;
    this.cehckAllSelect();
    this.sendSelectedProducts = this.selectedProducts.filter((selectedProduct) => selectedProduct.addBulkChecked);
  }

  addBulkProducts() {
    if (this.sendSelectedProducts.length > 0) {
      let ret: any = [];
      const analyticsSourceProducts = this.selectedProducts.filter((product) => product.addBulkChecked);
      this.selectedProducts = this.selectedProducts.filter((selectedProduct) => {
        const requestUrl = resolveCartRequestUrl(this.router.url, selectedProduct.cartContextUrl);
        if (selectedProduct.addBulkChecked && canBuildCartRequest(selectedProduct, requestUrl)) {
          const addSource = buildAddSource(
            selectedProduct.addSource?.[ADD_SOURCE_LIST_NAME_KEY],
            this.utmStorage.get()
          );
          ret.push(
            buildBulkCartRequest(selectedProduct, {
              currentUrl: this.router.url,
              slotUrl: selectedProduct.cartContextUrl,
              addSource,
            })
          );
          return false;
        } else {
          return selectedProduct;
        }
      });
      this.productService.selectProducts = this.selectedProducts;
      this.productService.emitResetProduct(this.selectedProducts);

      if (ret.length === 0) {
        this.sendSelectedProducts = [];
        return;
      }

      this.cartService.addToCarts(ret).subscribe(
        (carts) => {
          const dialog = this._openDialog({
            message: this.i18n.t('CART.ADDED_MIN'),
            close: () => {
              dialog.close();
            },
          });
          this.store.dispatch(new CartStore.SetCart(carts));
          this.gaService.logAddToCart(carts, undefined, {
            isChecked: true,
            eventLabel: 'QUICK_BULK',
            sourceMapperSaleProducts: analyticsSourceProducts,
          });
        },
        (error) => {
          this.errors = error;
          const errorDialog = this._openDialog({
            message: this.errors.message,
            close: () => {
              errorDialog.close();
            },
          });
        }
      );
      this.sendSelectedProducts = this.selectedProducts.filter((selectedProduct) => selectedProduct.addBulkChecked);
      if (this.selectedProducts.length === 0) this.reset();
    }
  }

  reset() {
    this.isShowAddToCartModal = false;
    this.productService.selectProducts = [];
    this.productService.emitResetProduct();
  }

  clickAllSelect() {
    this.isCheckedAll = !this.isCheckedAll;
    this.selectedProducts.map((selectedProduct) => {
      selectedProduct.addBulkChecked = this.isCheckedAll;
    });
    this.sendSelectedProducts = this.selectedProducts.filter((selectedProduct) => selectedProduct.addBulkChecked);
  }

  cehckAllSelect() {
    let cnt = 0;
    this.selectedProducts.forEach((selectedProduct) => {
      if (selectedProduct.addBulkChecked) {
        cnt++;
      }
    });
    this.isCheckedAll = this.selectedProducts.length === cnt;
  }

  onCloseAddToCartModal() {
    this.isShowAddToCartModal = false;
  }

  deleteSelect() {
    const dialog = this._openDialog({
      message: 'Do you want to delete the selected items?',
      close: () => {
        this.selectedProducts = this.selectedProducts.filter((selectedProduct) => !selectedProduct.addBulkChecked);
        if (this.selectedProducts <= 0) {
          this.reset();
        } else {
          this.productService.selectProducts = this.selectedProducts;
          this.productService.emitResetProduct(this.selectedProducts);
        }
        dialog.close();
      },
      cancel: () => {
        dialog.close();
      },
    });
  }
}
